import { render, staticRenderFns } from "./SubjectComponent.vue?vue&type=template&id=ad2152ac&scoped=true&"
import script from "./SubjectComponent.vue?vue&type=script&lang=js&"
export * from "./SubjectComponent.vue?vue&type=script&lang=js&"
import style0 from "./SubjectComponent.vue?vue&type=style&index=0&id=ad2152ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad2152ac",
  null
  
)

export default component.exports